import React from "react";
import { Box } from "@mui/material";
import BasicTab from "./BasicTab";
import { Outlet } from "react-router-dom";

function Define() {
	return (
		<Box sx={{ width: "100%", typography: "body1" }}>
         <BasicTab/>
         <Outlet/>
		</Box>
	);
}

export default Define;
